import Service			from "./../../Libs/Service";
import _				from "lodash";

import { Creative }		from "./Creative";
import { Layout } 		from "./Layout";
import { Publisher } 	from "./Publisher";
import {Elements} from "./Elements";

let Version = new Service({

	Name: "Version",

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Selected Creative Changed": function() {

			let creative = Creative.getCreative(Creative.SelectedCreative?.id);

			if (creative && Creative.isSelectedCreativeLoaded()) {

				this.autoSelectVersion();

			} else {

				this.selectVersion(null);

			}

		},

		"Creative Versions Loaded,Version Fully Loaded": function () {

			if (!Version.SelectedVersion && Creative.SelectedCreative) this.autoSelectVersion();

		},

		"Selected Version Removed": function() {

			if (Creative.SelectedCreative) this.autoSelectVersion();

		},

		"Creative Deleted": function(creativeId) {

			_.each(this.Versions, version => {

				if (version["creative_id"] === creativeId) delete this.Versions[version.id];

			});

			delete this.VersionsByCreative[creativeId];
			delete this.VersionsByCreativeByCodename[creativeId];

		},

		"Version Localization Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "localization");

		},

		"Version Assets Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "assets");

		},

		"Version Assets Original Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "assets-original");

		},

		"Version Screens Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "screens");

		},

		"Version Events Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "events");

		},

		"Version Elements Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "elements");

		},

		"Version Animations Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "animations");

		},

		"Version Animation Steps Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "animation-steps");

		},

		"Version Emitters Loaded": function(versionId) {

			this.markVersionPartAsLoaded(versionId, "emitters");

		}

	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"Versions": function(versions, data, size, serverId) {

			this.updateVersions(versions, !data.VersionsCreativeId, serverId);

			if (data.VersionsCreativeId) Broadcast.call("Creative Versions Loaded", [data.VersionsCreativeId]);

		},

		"NewVersionCreated": function(versionId) {

			this.selectVersion(versionId);

		},

		"GlobalSearchVersions": function (data) {

			Broadcast.call("Global Search Results", [data]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и креативов
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.VersionsByServer = {};
		this.VersionsByCreativeByServer = {};
		this.VersionsByCreativeByCodenameByServer = {};
		this.loadedVersionsByServer = {};

		this.SelectedVersion = null;

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Versions[versionId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Versions = this.getServerMap(this.VersionsByServer, serverId);
		this.VersionsByCreative = this.getServerMap(this.VersionsByCreativeByServer, serverId);
		this.VersionsByCreativeByCodename = this.getServerMap(this.VersionsByCreativeByCodenameByServer, serverId);
		this.loadedVersions = this.getServerMap(this.loadedVersionsByServer, serverId);

		//Выбранная версия осталась от прежней ноды: id версий на разных нодах совпадают
		this.SelectedVersion = null;

		Broadcast.call("Selected Version Switched");

	},

	// Ключ localStorage последней открытой версии креатива: номер ноды обязателен,
	// потому что id креативов на разных нодах совпадают
	getStoredVersionKey(creativeId) {

		return `selected-version-for-creative-${Publisher.getSelectedServerId()}-${creativeId}`;

	},

	// Версии одного креатива: объект versionId -> версия
	getVersionsByCreative(creativeId) {

		return this.VersionsByCreative[creativeId];

	},

	// Версия по id (активные карты - версии рабочей ноды)
	getVersion(versionId) {

		return this.Versions[versionId];

	},

	// Помечаем часть версии как загруженную
	// И проверяем загружены ли все части, если да то помечаем всю версию как загруженную полностью
	markVersionPartAsLoaded(versionId, partName) {

		let lp = this.loadedVersions[versionId];

		if (!lp) lp = this.loadedVersions[versionId] = {};

		lp[partName] = true;

		if (lp["assets"] && lp["assets-original"] && lp["localization"] && lp["settings"] && lp["settings-original"] && lp["screens"] && lp["events"] && lp["elements"] && lp["animations"] && lp["animation-steps"] && lp["emitters"]) {

			let oldLoaded = lp.loaded;

			lp.loaded = true;

			if (!oldLoaded) {

				Broadcast.call("Version Fully Loaded", [versionId]);

				if (Version.SelectedVersion && parseInt(versionId) === Version.SelectedVersion.id) Broadcast.call("Selected Version Fully Loaded");

			}

		}

	},

	updateVersions(versions, isBroadcast = true, serverId) {

		//Версии кладём в карты ноды, с которой пришли данные (у админа подключены все ноды)
		serverId = serverId || this.NodeServerId;

		_.each(versions, (version, version_id) => {

			this.updateVersion(version, this.getServerVersion(serverId, version_id), isBroadcast, serverId);

		});

	},

	// Версия из карт указанной ноды
	getServerVersion(serverId, versionId) {

		return this.getServerMap(this.VersionsByServer, serverId)[versionId];

	},

	updateVersion(version, oldVersion, isBroadcast = true, serverId) {

		serverId = serverId || this.NodeServerId;

		let versions = this.getServerMap(this.VersionsByServer, serverId),
			versionsByCreative = this.getServerMap(this.VersionsByCreativeByServer, serverId),
			versionsByCreativeByCodename = this.getServerMap(this.VersionsByCreativeByCodenameByServer, serverId);

		if (version) {

			versions[version.id] = version;

			let creativeId = version["creative_id"];

			if (!versionsByCreative[creativeId]) versionsByCreative[creativeId] = {};
			versionsByCreative[creativeId][version.id] = version;

			if (version.codename) {

				if (!versionsByCreativeByCodename[creativeId]) versionsByCreativeByCodename[creativeId] = {};
				versionsByCreativeByCodename[creativeId][version.codename] = version;

			}

			let copyFrom = _.find(_.keys(version.Tags), tag => tag.indexOf('copy-from-') === 0);

			if (copyFrom) version.baseVersionId = parseInt(copyFrom.replace('copy-from-', ''));

			if (!version.Tags.custom) version.baseVersionId = version.id;

			if (!version.options.endCardMarkers) version.options.endCardMarkers = [];

			let templateId = version.options.templateId;
			if (templateId) version.templateProps = Metadata.Templates?.[templateId];

			//Выбранную версию обновляем, только когда данные пришли с её ноды
			if (serverId === this.NodeServerId && this.SelectedVersion && this.SelectedVersion.id === version.id) this.SelectedVersion = version;

		} else {

			delete versions[oldVersion.id];

			let creativeVersions = versionsByCreative[oldVersion["creative_id"]];

			if (creativeVersions) delete creativeVersions[oldVersion.id];

			let creativeVersionsByCodename = versionsByCreativeByCodename[oldVersion["creative_id"]];

			if (creativeVersionsByCodename) delete creativeVersionsByCodename[oldVersion.codename];

		}

		if (isBroadcast) {

			let eventPrefixes = ["Version"];
			if (version?.id === Version.SelectedVersion?.id || oldVersion?.id === Version.SelectedVersion?.id) eventPrefixes.push("Selected Version");
			if (version?.creative_id === Creative.SelectedCreative?.id || oldVersion?.creative_id === Creative.SelectedCreative?.id) eventPrefixes.push("Selected Creative Version");

			this.broadcastChanges(oldVersion, version, eventPrefixes);

		}

	},

	autoSelectVersion() {

		let versionId = window.localStorage.getItem(this.getStoredVersionKey(Creative.SelectedCreative.id));

		let creativeVersions = this.getVersionsByCreative(Creative.SelectedCreative.id),
			versions = _.values(creativeVersions || {});

		if (creativeVersions && creativeVersions[versionId]) Version.selectVersion(parseInt(versionId));

		else if (versions[0]) Version.selectVersion(versions[0].id);

		else Version.selectVersion(null);

	},

	selectVersion(versionId) {

		let oldSelectedVersion = this.SelectedVersion;

		this.SelectedVersion = this.getVersion(versionId);

		if (this.SelectedVersion) window.localStorage.setItem(this.getStoredVersionKey(this.SelectedVersion["creative_id"]), versionId);

		Broadcast.call("Selected Version Switched");

		if (!oldSelectedVersion || oldSelectedVersion.id !== this.SelectedVersion?.id) Layout.setVersion(versionId);

	},

	getVersionScreenshot(creative, version) {

		if (version.options.screenshotFileName) return `url(project-assets/project-${creative.id}/version-${version.id}/${version.options.screenshotFileName})`;
		else return `url(Images/Icons/EndCards/${creative.templateProps.codename}.png)`;

	},

	canCopyVersion() {

		if (User.currentUser && User.currentUser.isAdmin) return true;
		if (Creative.SelectedCreative && Creative.SelectedCreative.options && Creative.SelectedCreative.options.disableNewVersionsCreation) return false;
		if (!Publisher || !Publisher.SelectedPublisher || Publisher.SelectedPublisher.options.DisableNewVersionsCreation) return false;
		return true;

	}

});

window.Version = Version;

export { Version }

